import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';

@Component({
  selector: 'app-welcome-screen',
  templateUrl: './welcome-screen.component.html',
  styleUrls: ['./welcome-screen.component.scss']
})
export class WelcomeScreenComponent implements OnInit {

  @Input() planData: any;
  @Output() activateRedirectPress = new EventEmitter<void>();

  constructor() { }

  ngOnInit() {
  }

  onRedirectButtonClick() {
    this.activateRedirectPress.emit();
  }
}
